import PharmacotherapyMenu from "./TreatmentMenuItems/PharmacotherapyMenu";
import SurgeryMenu from "./TreatmentMenuItems/SurgeryMenu";
interface TreatmentMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}
const TreatmentsMenu: React.FC<TreatmentMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  return (
    <>
      <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">Surgery </div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <SurgeryMenu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}
              setIsFiltersOpen={setIsFiltersOpen}></SurgeryMenu>
          </p>
        </div>
      </div>
      <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">
            Pharmacotherapy{" "}
          </div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <PharmacotherapyMenu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}
              setIsFiltersOpen={setIsFiltersOpen}></PharmacotherapyMenu>
          </p>
        </div>
      </div>
    </>
  );
};

export default TreatmentsMenu;
